// Maps the active i18n language (e.g. 'de', 'deConstruction', 'en-US') to a
// locale the documentation API supports ('de' or 'en').
export const toApiLocale = (language) =>
  language && language.startsWith('en') ? 'en' : 'de';
